export default __webpack_public_path__ + "static/media/Arrow 2.4adc5c21.svg";